<template>
  <div class="app-container">
    <div class="order-btn">
      <vxe-button @click="returnFun()">返回</vxe-button>
      <vxe-button status="primary" @click="saveMaterial()">保存</vxe-button>
    </div>
    <a-divider/>
    <div class="orderFormLine">订单信息</div>
    <div class="budgetBox">
      <a-form ref="orderForm" class="UniformCss" :inline="true" :model="order" label-width="100px">
        <a-row>
          <a-col :span="3">
            <a-form-item label="订单编号" prop="applyOrderCode">
              <a-input v-model="order.applyOrderCode" :disabled="true" />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="收货地区">
              <a-input v-model="order.receiveArea" disabled />
            </a-form-item>
          </a-col> -->
          <a-col :span="3">
            <a-form-item label="申领部门">
              <a-input v-model="order.orgName" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item label="申领人">
              <a-input v-model="order.applyMan" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item label="收货人" prop="receiverName">
              <a-input v-model="order.receiverName" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item label="收货人联系方式">
              <a-input v-model="order.receivePhone" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="9">
            <a-form-item label="收货地址">
              <a-input v-model="order.address" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item label="审批总项数">
              <a-input v-model="order.orderMaterialCount" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item label="审批总数量">
              <a-input v-model="order.approveNums" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item label="审批总金额">
              <a-input v-model="order.approveTotalSums" disabled />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div class="orderFormLine">物料信息</div>
      <div>
        <div style="padding: 10px 0px;" v-if="!isdetail">
          <!-- <vxe-button v-waves style="background: #40bef8; border: 0px" status="primary" @click="batchInputBtn">
            批量编辑
          </vxe-button> -->
        </div>
        <vxe-table
            :data="materialList"
            border
            style="width: 100%"
            show-header-overflow
            show-overflow
            :header-cell-style="{background:'#eef1f6'}"

        >
          <!-- <vxe-column type="checkbox" width="60" align="center" /> -->
          <!-- <vxe-table-column field="logisticsOrderCode" title="物流单号" width="130" align="center" /> -->
          <vxe-table-column field="materialCode" title="物料号"  align="center" />
          <vxe-table-column field="materialName" title="物料名称"  align="center" />
          <!--  <vxe-table-column field="storage" title="数量" width="100" align="center" /> -->
          <!--  <vxe-table-column field="price" title="申领价" width="100" align="center" /> -->
          <!--  <vxe-table-column field="nums" title="申领数量" width="100" align="center" /> -->
          <!--  <vxe-table-column field="totalSums" title="申领总金额" width="100" align="center" /> -->
          <vxe-table-column field="approveNums" title="审批数量"  align="center" />
          <!-- <vxe-table-column field="approveTotalSums" title="审批总金额" width="100" align="center" /> -->
          <!-- <vxe-table-column field="receiveNums" title="收货数量" width="100" align="center" />  -->
          <!--  <vxe-table-column field="receiveTime" title="收货时间" width="150" align="center" />  -->
          <!--  <vxe-table-column field="receiveMan" title="收货确认人" width="100" align="center" />  -->
          <!--  <vxe-table-column field="caption" title="物料说明" width="100" align="center" />  -->
          <vxe-table-column field="applyRemarks" title="申领备注" width="400" align="center" />
          <!-- <vxe-table-column title="操作" v-if="!isdetail" align="center" fixed="right" width="80"> -->
          <!-- <template  #default="{ row }"> -->
          <!-- <a-button size="small" v-if="isdetail" type="link" @click="detailFun(row)">查看</a-button> -->
          <!-- <a-button size="small" type="link" @click="detailFun(row)">修改</a-button>
        </template> -->
          <!-- </vxe-table-column> -->
        </vxe-table>
        <!-- <ApproveDeliveryDialog :visible.sync="dialogVisible" :orderMaterial.sync="rowMaterial" :pictures="picList" :isdetail="isdetail" @saveMaterial="saveMaterial" @cancel="cancel" @close="close" /> -->
      </div>
      <!-- v-model="item.number" -->
      <!-- v-model="logisticsOrderCode" -->

      <div class="orderFormLine">物流信息</div>
      <div slot="tip" class="el-upload__tip">物流单号输入后需要点击“添加物流单号”按钮才可保存</div>
      <div style="margin: 20px 0;">
        <div v-for="(item, index) in logisticsList" :key="index" style="margin-bottom: 10px;">
          <a-input v-model="logisticsList[index]" placeholder="物流单号输入后需要点击添加物流单号按钮才可保存" style="width: 300px; margin-right: 10px;"></a-input>
          <a-button type="danger" @click="removeLogistics(index)" v-if="logisticsList.length > 1">删除</a-button>
        </div>
        <a-input v-model="newLogisticsNumber" placeholder="请输入物流单号" style="width: 300px; margin-right: 10px;"></a-input>
        <a-button type="primary" class="blue-btn" @click="addLogistics">添加物流单号</a-button>
      </div>

      <!-- <div>
        <el-collapse v-model="collapseNumber" class="collapse-box" style="margin-bottom:10px">
          <el-collapse-item class="collapseItem" title="提报审核历史" name="default">
            <el-table :data="findHistTasksData" :loading="approveLoading" border stripe style="width: 100%">
              <el-table-column prop="displayName" label="审核部门" />
              <el-table-column prop="operatorName" label="审核人" />
              <el-table-column prop="finishTime" label="审核时间" />
              <el-table-column prop="amounts" label="申请费用(元)" align="right">
                <template #default="{ row }">
                  <span v-if="row.amounts">
                    {{ row.amounts | toThousandNumFilter }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="approveCost" label="审核费用(元)" align="right">
                <template #default="{ row }">
                  <span v-if="row.approveCost">
                    {{ row.approveCost | toThousandNumFilter }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" />
              <el-table-column prop="approveMsg" label="审核意见" />
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </div> -->
      <!-- 批量输入 -->
      <a-modal title="批量输入" :visible.sync="batchInputShow" width="35%" closable destroyOnClose @cancel="() => batchInputShow = false">
        <el-form ref="batchInputF" :inline="true" :model="batchData" class="UniformCss" label-width="90px">
          <a-row>
            <a-col>
              <el-form-item label="物流单号:" prop="logisticsOrderCode" :rules="[{ required: true, message: '物流单号不能为空!', trigger: 'blur' }]">
                <a-input v-model="batchData.logisticsOrderCode"  oninput="value=value.replace(/\D/g, '')" />
              </el-form-item>
            </a-col>
          </a-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <vxe-button @click="batchInputShow = false">取 消</vxe-button>
          <vxe-button status="primary" @click="batchInputFun">确 定</vxe-button>
        </span>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { getOrderById, findOrderDetailList, getMaterialById, getImgs,saveMaterialOrderLogistics,findMaterialOrderLogisticsList, findAddressListAll} from '@/api/material'
// import ApproveDeliveryDialog from './components/ApproveDeliveryDialog.vue'
import { setInitImg } from '@/utils/Picture/transferFile'
import { findTaskInfos, findDisTaskInfos } from '@/api/wf_process.js'
export default {
  name: 'ApplyOrderDetail',
  // components: {
  //   ApproveDeliveryDialog
  // },
  data() {
    return {
      collapseNumber: 'default',
      findHistTasksData: [],
      approveLoading: false,
      order: {},
      materialList: [],
      dialogVisible: false,
      rowMaterial: {},
      picList: [],
      isdetail: null,
      batchData:{},
      batchInputShow: false,
      selectionVal: [],   //  选中的数据
      logisticsOrderCode:'',
      logisticsList: [], // 物流单号列表
      newLogisticsNumber: '', // 用于存储输入的物流单号
      receiveAddressList: [],
      // 用于用户查询（与审核页保持一致结构1）
      factor: { code: '', symbol: '', values: '' },
      listQuery: { page: 1, limit: 1, importance: undefined, domain: 'center', title: undefined, type: undefined, conditions: [], sort: '+id' }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.order.id = this.$route.params.id
      // 仅拉取订单+明细+历史，不再做任何收货人兜底覆盖
      this.findAddressListAll()
      this.getOrderById()
      this.getOrderlDetail()
      this.getOrderLogisticsList(this.$route.params.id) 
      // this.viewApproveDetail()
    }
    if(this.$route.query.isdetail == 'false') {
      this.isdetail = false
    }else {
      this.isdetail = true
    }
  },
  activated() {
    // 组件被 keep-alive 缓存时，返回本页也能及时回填收货人
    this.ensureReceiverName()
  },
  watch: {
    'order._receiverKey'() {
      this.ensureReceiverName()
    },
    receiveAddressList() {
      this.ensureReceiverName()
    },
    findHistTasksData() {
      this.ensureReceiverName()
    }
  },
  methods: {

    async findAddressListAll() {
      const params = {
      }
      await findAddressListAll(params).then(res => {
        this.receiveAddressList = Array.isArray(res.data) ? res.data : []
        // 地址簿到位后立即尝试映射姓名
        this.ensureReceiverName()
      })
    },

    // 将收货人ID映射为姓名： 后端姓名(receiverName) -> 优先地址簿(recipientName)
    ensureReceiverName() {
      if (!this.order) return
      const rKey = this.order._receiverKey
      // const rKey = this.order.receiveId || this.order.receiver || this.order._receiverKey

      if (!rKey) return
      // 1) 后端直接给的姓名（标准字段）
      if (this.order.receiverName) return

      // 2) 地址簿映射
      if (Array.isArray(this.receiveAddressList) && this.receiveAddressList.length) {
        const hit = this.receiveAddressList.find(it => String(it.id) === String(rKey))
        if (hit && hit.recipientName) {
          this.order.receiverName = hit.recipientName
          return
        }
      }
    },

    getOrderLogisticsList(id) {
        findMaterialOrderLogisticsList(id).then(res => {
        if (res.code === 1) {
          // this.OrderLogisticsList = res.data.list
          // this.logisticsList = res.data
          this.logisticsList = res.data.map(item => {
  return item && item.trackingNumber ? item.trackingNumber.trim() : '';
});
          console.log(this.logisticsList,'---1111----');
        } else {
          this.$message.error(res.message)
        }
      })
    },    
    getOrderById() {
      getOrderById(this.order.id).then(res => {
        if (res.code === 1) {
          this.order = res.data
          console.log(this.order,'this.order1');
          console.log(res.data.receiverName, 'this.order1.receiverName after mapped')

          if (res.data && res.data.receiverName) this.order.receiverName = res.data.receiverName
          this.order._receiverKey = this.order.receiveId || this.order.receiver || ''
          this.ensureReceiverName()
          this.$nextTick(() => {
          console.log(this.order.receiverName, 'receiverName after mapped')
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getOrderlDetail() {
      const data = { orderId: Number(this.order.id) }
      findOrderDetailList(data).then(res => {
        if (res.code === 1) {
          this.materialList = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
    },
    detailFun(row) {
      // console.log(row,'000');

      this.dialogVisible = true
      this.rowMaterial = row
      this.getMaterialinfo(row)
    },
    getMaterialinfo(row) {
      getMaterialById(row.materialId).then(res => {
        if (res.code === 1) {
          if (res.data.fileNames.length > 0) {
            this.fileNames = res.data.fileNames
            this.inItImages()
          }
        }
      })
    },

    viewApproveDetail() {
      const param = {
        orderId: this.$route.query.applyOrderId || ''
        // orderId: 'c3dd1125e8bb4f7b99a1e33aa52c679a'
      }
      this.approveLoading = true
      if (this.$route.query.orderStatus === '3') {
        findDisTaskInfos(param).then(res => {
          this.findHistTasksData = res.data
          this.approveLoading = false
        })
      } else {
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.findHistTasksData = res.data
            // this.findHistTasksData.forEach(item => {
            //   if (!item.his) {
            //     item.operatorName = this.signData.applyAuditorNames
            //     item.finishTime = '正在处理'
            //   }
            // })
            this.approveLoading = false
          }
        })
      }
    },
    inItImages() {
      this.fileNames.forEach(name => {
        console.log(name)
        const data = { fileName: name }
        getImgs(data).then(res => {
          const file = setInitImg(res, name)
          this.picList.push(file.url)
        })
      })
    },
    close() {
      this.dialogVisible = false
      this.rowMaterial ={}
    },

    cancel() {
      this.dialogVisible = false
      this.rowMaterial ={}
    },
    returnFun() {
      this.returnListFun()
    },

    // 获取选中的 数据
    selectionChange(val) {
      this.selectionVal = val.records
      console.log(val,'---vall----');


    },
    //批量输入
    batchInputBtn() {
      if (this.selectionVal.length > 0) {
        this.batchInputShow = true
      }else {
        this.$message.error('选择修改的数据')
      }
    },
    //批量修改保存按钮
    // batchInputFun() {
    //   this.selectionVal.forEach((item, index) => {
    //     this.$set(this.selectionVal, index, { ...item, 'logisticsOrderCode': this.batchData.logisticsOrderCode });
    //   });

    //   console.log(this.selectionVal,'pppp');

    //   this.$refs.batchInputF.validate(v => {
    //     if (v) {
    //       saveOrderMaterial(this.selectionVal).then(res => {
    //         if (res.code === 1) {
    //           this.$message.success('保存成功')
    //           this.batchInputShow = false
    //           this.getOrderById()
    //           this.getOrderlDetail()

    //         } else {
    //           this.$message.error('保存失败')
    //         }
    //       })
    //     }
    //   })
    // },

    //  保存
    //   saveOrderMaterial([data]).then(res => {
    saveMaterial() {
      // saveOrderMaterial(logisticsList).then(res => {
      const params = {
        orderId: this.order.id,
        trackingNumberList: this.logisticsList
      }
      saveMaterialOrderLogistics(params).then(res => {
        if (res.code === 1) {
          this.$message.success('保存成功')
          this.dialogVisible = false
        } else {
          this.$message.error('保存失败')
        }
      })
    },
    returnListFun() {
      if(this.$route.query.type === 'myToDolistGuangXuan'){
        // 跳转路由
        this.$closePage('/publicizeMaterialManagement/applyOrderDetail', '/publicizeMaterialManagement/delivery')
      }else if(this.$route.query.type === 'myToDolistShiChang'){
        // 跳转路由
        this.$closePage('/publicizeMaterialManagement/applyOrderDetail', '/terminalActivity/delivery')
      }
      // else {
      //   // 跳转路由
      //   this.$closePage('/publicizeMaterialManagement/applyOrderDetail', '/publicizeMaterialManagement/advertiseMaterialRequisition')
      // }
    },

    // 添加物流单号输入框
    addLogistics() {
      if (this.newLogisticsNumber.trim() !== '') {
        this.logisticsList.push(this.newLogisticsNumber); // 添加新的物流项
        this.newLogisticsNumber = ''; // 清空输入框
      }
      console.log(JSON.stringify(this.logisticsList), 'this.logisticsList');
    },

    // 删除物流单号输入框
    removeLogistics(index) {
      this.logisticsList.splice(index, 1)
    },
  }
}
</script>
<style lang="less" scoped>
.orderFormLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}

.order-btn {
  margin-top: 20px;
}
</style>
